module.exports = require("workbox-webpack-plugin");